import {AxiosResponse} from "axios";
import AuthenticationResponse from "../domain/endpoint/AuthenticationResponse";
import AuthenticationRequest from "../domain/endpoint/AuthenticationRequest";
import axios from "./axios";

export default class AuthenticationController {
    public static authenticate(authenticationRequest: AuthenticationRequest): Promise<AuthenticationResponse> {
        return new Promise ((resolve, reject) => {
            axios.post("/auth", authenticationRequest)
                .then ((res: AxiosResponse) => {
                    resolve(res.data);
                })
                .catch ((err: Error) => {
                    reject(err);
                });
        });
    }
}
